import { FC } from 'react'
import { useSelector } from 'shared-redux'
import { selectedMenuCategory } from 'shared-redux/state'
import { MenuStandardSlideOutCategoriesDesktop } from 'storefront-modules/layout/Menu'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

export interface ISlideOutCategoriesProps {}

const SlideOutCategories: FC<ISlideOutCategoriesProps> = () => {
  const appConfig = useAppConfig()
  const menuCategory = useSelector(selectedMenuCategory)

  return (
    <MenuStandardSlideOutCategoriesDesktop
      currentTopCategory={menuCategory}
      paths={{
        categories: appConfig.paths.categoriesUrlPath
      }}
      menuCategoriesThumbnails={appConfig.menuCategoriesThumbnails}
      topNavSlideOutFeaturedCategories={appConfig.topNavSlideOutFeaturedCategories}
      columnWrapApproach="wrap"
    />
  )
}

export default SlideOutCategories
